import { ProductFruits } from 'react-product-fruits';
import { useAuth } from 'hooks';
import { ReactElement } from 'react';

interface UserInfo {
  username: string;
  email: string;
}

interface UseProductFruitsProps {
  language?: string;
}

export function useProductFruits({
  language = 'pt',
}: UseProductFruitsProps = {}): ReactElement | null {
  const { nome, documento } = useAuth();

  if (!nome || !documento) {
    return null;
  }

  const userInfo: UserInfo = {
    username: nome,
    email: documento,
  };

  const codigo = process.env.REACT_APP_PRODUCT_FRUITS_CODE;

  if (!codigo) {
    return null;
  }

  return (
    <ProductFruits workspaceCode={codigo} language={language} user={userInfo} />
  );
}
